import * as React from 'react';
import { PropsWithChildren, ReactNode } from 'react';
import { faSquareUpRight } from '@fortawesome/free-solid-svg-icons/faSquareUpRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  href: string;
  externalIcon?: boolean;
  className?: string;
}

const defaultProps: Partial<Props> = {
  externalIcon: true,
};

export const ExternalLink: React.FC<PropsWithChildren<Props>> = (props: PropsWithChildren<Props>): ReactNode => {
  props = {...defaultProps, ...props};
  return <a
    href={props.href}
    target={'_blank'}
    rel={'noopener noreferrer'}
    className={`no-underline flex align-items-center text-primary-800 ${props.className || ''} flex gap-1 w-full`}
  >
    <span className={'w-full'} style={{overflowWrap: 'break-word'}}>
      {props.children}
      {props.externalIcon && <>&nbsp;<FontAwesomeIcon icon={faSquareUpRight}/></>}
    </span>
  </a>;

};
